// Kleuren voor een keuzevraag waarvan de antwoorden een schaal vormen
// ('Zeer goed' … 'Zeer slecht'). Nodig omdat een keuzevraag standaard
// categorische kleuren krijgt: bij de keynotevraag van De Doorbraak was
// 'Zeer goed' koraal en las daardoor als negatief (testronde 2026-10-05).
//
// Een keuzevraag legt niet vast of zijn antwoorden een schaal zijn, of in welke
// richting; dat kiest de maker van de rapportage in het Vraag-blok
// ('Kleuren'). Wat buiten de schaal valt herkennen we aan de tekst — een
// vuistregel, want ook dat staat nergens vast.
// AI-CONTEXT: See docs/features/chart-color-system.md

import { getDivergingColors, OTHER_BUCKET_COLOR } from '../chartPalette'

/** Antwoorden die geen plek op de schaal hebben. */
const OUTSIDE_SCALE = /niet van toepassing|weet (ik )?niet|geen mening|^n\.?v\.?t\.?$/i

/**
 * @param {Array<{id: string, name: string}>} options - Antwoordopties in volgorde
 * @param {'positive-first'|'negative-first'|''} [direction] - Waar de schaal begint
 * @returns {Object<string, string>|null} optie-ID → kleur, of null zonder schaalkeuze
 */
const scaleOptionColors = (options, direction) => {
    if (direction !== 'positive-first' && direction !== 'negative-first') return null

    const onScale = options.filter(o => !OUTSIDE_SCALE.test(String(o.name || '').trim()))
    const ramp = getDivergingColors(onScale.length)
    // Het palet loopt van rood (negatief) naar teal (positief).
    const ordered = direction === 'positive-first' ? [...ramp].reverse() : ramp

    return Object.fromEntries(options.map(o => {
        const index = onScale.indexOf(o)
        return [o.id, index === -1 ? OTHER_BUCKET_COLOR : ordered[index]]
    }))
}

export default scaleOptionColors
